































import Vue, { PropOptions } from 'vue';
import util from '@/components/util';

export interface IUserSideModalData {
  value: number;
  texts: string[];
}

export default Vue.extend({
  name: 'UserSideModal',
  components: { ...util},
  props: {
    title: String,
    list: Array as PropOptions<IUserSideModalData[]>,
  },
  data() {
    return {
      selectList: [] as number[],
      searchValue: '',
    };
  },
  computed: {
    LIST(): IUserSideModalData[] {
      return this.list.filter((v) => (this.searchValue.length > 0 ? v.texts.join().indexOf(this.searchValue) >= 0 : true));
    },
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickAdd() {
      this.$emit('add', this.selectList);
    },
  },
});
